import { render, staticRenderFns } from "./VersionsPlane.vue?vue&type=template&id=89d0f8d0&lang=pug"
import script from "./VersionsPlane.vue?vue&type=script&lang=js"
export * from "./VersionsPlane.vue?vue&type=script&lang=js"
import style0 from "./VersionsPlane.vue?vue&type=style&index=0&id=89d0f8d0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports